import { createContext } from 'react';

export const SidebarToggleContext = createContext({
  opened: false as boolean,
  rightOpened: false as boolean,
});
